import { getAvailableAWayToMoveSlotOptions } from '../../utils/eventRegistrationFormTypes'

const AWayToMoveSlotPicker = ({
  name,
  selectedSlot,
  onChange,
  disabled = false,
}) => {
  const availableSlots = getAvailableAWayToMoveSlotOptions()

  if (availableSlots.length === 0) {
    return (
      <div className="rounded-xl border border-amber-200 bg-amber-50 px-3 py-3 text-sm text-amber-800">
        No trial slots are available right now.
      </div>
    )
  }

  return (
    <div>
      <p className="block text-xs font-semibold uppercase tracking-[0.14em] text-gray-500 mb-2">
        Free trial slot <span className="text-red-500">*</span>
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {availableSlots.map((slot) => {
          const isSelected = selectedSlot === slot.value
          return (
            <label
              key={slot.value}
              className={`group flex min-h-[50px] cursor-pointer items-center justify-between gap-3 rounded-lg border px-3 py-2.5 transition-colors ${
                isSelected
                  ? 'border-red-500 bg-red-50 shadow-sm'
                  : 'border-gray-300 bg-white hover:border-red-300 hover:bg-red-50/40'
              } ${disabled ? 'cursor-not-allowed opacity-60' : ''}`}
            >
              <input
                type="radio"
                name={name}
                value={slot.value}
                checked={isSelected}
                onChange={() => onChange(slot.value)}
                required
                disabled={disabled}
                className="sr-only"
              />
              <span className="min-w-0 text-left">
                <span className="block text-[10px] font-semibold uppercase tracking-[0.16em] text-red-500">
                  {slot.weekday}
                </span>
                <span className="block whitespace-nowrap text-sm font-semibold text-gray-900">
                  {slot.label}
                </span>
              </span>
              <span
                aria-hidden="true"
                className={`h-4 w-4 flex-shrink-0 rounded-full border transition-colors ${
                  isSelected
                    ? 'border-red-500 bg-red-500 shadow-[inset_0_0_0_3px_white]'
                    : 'border-gray-300 bg-white group-hover:border-red-300'
                }`}
              />
            </label>
          )
        })}
      </div>
    </div>
  )
}

export default AWayToMoveSlotPicker
